export enum ColorPaletteType {
  Preset = 1,
  Brand  = 2,
}